module.exports = __webpack_public_path__ + "img/bannerRed.a02ae8da.jpg";